export default function(seconds, framerate){

  if(!framerate) var framerate = 24

  var f = Math.floor((seconds % 1) * framerate)

  var s = Math.floor(seconds)

  var m = Math.floor(s / 60)

  var h = Math.floor(m / 60)

  m = m % 60
  s = s % 60

  if (h < 10) h = "0" + h
  if (m < 10) m = "0" + m
  if (s < 10) s = "0" + s
  if (f < 10) f = "0" + f

  var smpte = h + ":" + m + ":" + s + ":" + f

  return smpte

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/secondsToSmpte/secondsToSmpte.js